import React from 'react';
import PropTypes from 'prop-types';

const variants = {
  primary: 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md shadow-blue-500/10 hover:shadow-blue-500/20 active:scale-95',
  secondary: 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-700/50 active:scale-95',
  danger: 'bg-red-500 text-white hover:bg-red-600 active:scale-95',
  ghost: 'text-gray-600 hover:bg-gray-100 dark:text-slate-300 dark:hover:bg-slate-700/50 active:scale-95'
};

const sizes = {
  sm: 'p-1.5 rounded-lg',
  md: 'p-2.5 rounded-xl',
  lg: 'p-3.5 rounded-2xl'
};

const IconButton = ({ 
  icon: Icon, 
  ariaLabel, 
  variant = 'secondary', 
  size = 'md', 
  className = '', 
  disabled = false, 
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-sky-400 dark:focus:ring-offset-slate-900 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none';

  return (
    <button
      aria-label={ariaLabel}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {React.isValidElement(Icon) ? Icon : <Icon size={18} />}
    </button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  disabled: PropTypes.bool
};

export default IconButton;
